import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { APIComponent } from '../../../shared/api.component';
import { BaseLoopBackStorageService } from '../../../services/storage/loopback/base.service';
import { AccountLoopBackApiService } from '../../../services/api/loopback/custom/account.service';
import { BaseLoopBackApiService } from '../../../services/api/loopback/base.service';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { Filter } from '../../../shared/filter';
import { SWAL_API_FIND, SwalErrorHandler, PAGE_ACTION, ITEMS_PER_PAGE, OPERATOR, MULTISELECT_LIMIT } from '../../../shared/constants';
import { ExportService } from '../../../services/export.service';
import * as moment from 'moment-timezone';

declare const swal: any;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'drx-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class ReportingComponent extends APIComponent {
  public title = 'DeviceCheck Reports';
  public users: any = [];
  public exportData: any = [];
  public exportFilter = null;
  public processing = false;
  public btnCaption = 'Generate Report (.xlsx)';
  private exportService = new ExportService();
  public constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected formBuilder: FormBuilder,
    protected storageService: BaseLoopBackStorageService,
    protected apiService: AccountLoopBackApiService,
    protected reportService: BaseLoopBackApiService
  ) {
    super(route, router, formBuilder, storageService, apiService);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.loadItems();
    this.createForm();
  }

  public createForm() {
    this.form = this.formBuilder.group({
      user_list: ['', Validators.required],
      from_date: [moment().startOf('month').toISOString(), Validators.required],
      to_date: [moment().toISOString(), Validators.required],
    });
  }
  exportProcess(user_list, newFromDate, newToDate, timeZone, totalItems, offset, fileName = 'data_list') {
    let users = this.items;
    let nextItem = offset * 1000;
    let newFilter = new Filter({
      limit: 1000,
      offset: nextItem,
      fields: [
        'created', 'userId', 'ip_address', 'status', 'imei'//,'partnerid','branchid'
      ],
      where: {
        userId: {
          inq: user_list
        },
        created: {
          between: [newFromDate.toISOString(), newToDate.toISOString()]
        }
      },
      order: 'created DESC'
    });

    this.reportService.find(newFilter)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res.data.length > 0) {
          this.btnCaption = 'Generating file (' + parseInt((nextItem * 100 / totalItems).toString()) + '%). Please wait!';
          let temp = this.exportData;
          res.data.forEach(function (item, index) {
            //let created = new Date(item.created);
            let createdDate = moment(item.created).tz(timeZone);
            temp.push({
              'Query Date/Time': createdDate.format("MM/DD/YYYY hh:mm:ss A"),
              'Time Zone': createdDate.format("z"),
              'User Name': users[users.map(e => e.email).indexOf(item.userId)].name,
              'Query Status': item.status,
              'IP Address': item.ip_address,
              'IMEI': item.imei,
            });
          });
          this.exportData = temp;
          this.exportProcess(user_list, newFromDate, newToDate, timeZone, totalItems, ++offset, fileName);
        } else {
          this.processing = false;
          this.btnCaption = 'Generate Report (.xlsx)';
          this.exportService.exportExcel(this.exportData, fileName);
        }
      }, error => {
        swal(SwalErrorHandler.errorMessage(error));
      });
  }
  exportClick() {
    let data = this.form.value;
    let dbTimeZone = 'UTC';
    let timeZone = moment.tz.guess();
    //let timeZone = 'America/New_York';
    let tempDate = moment(data.from_date).format('YYYY-MM-DD 00:00:01');
    let newFromDate = moment.tz(tempDate, timeZone);
    tempDate = moment(data.to_date).format('YYYY-MM-DD 23:59:59');
    let newToDate = moment.tz(tempDate, timeZone);
    //console.log(newFromDate.toISOString(), newToDate.toISOString());
    this.processing = true;
    this.btnCaption = 'Generating file. Please wait!';
    this.reportService.modelName = 'Rtl';
    let where = {
      userId: {
        inq: data.user_list
      },
      created: {
        between: [newFromDate.tz(dbTimeZone).toISOString(), newToDate.toISOString()]
      }
    };
    this.exportData = [];
    this.reportService.count(where)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        if (res.data.count > 0) {
          this.exportProcess(data.user_list, newFromDate.tz(dbTimeZone), newToDate.tz(dbTimeZone), timeZone, res.data.count, 0, 'DeviceCheckAPIReport_' + newFromDate.toISOString().slice(0, 10) + '_' + newToDate.toISOString().slice(0, 10));
        } else {
          this.processing = false;
          this.btnCaption = 'Generate Report (.xlsx)';
          swal(SWAL_API_FIND.NOITEM_WARNING);
        }
      }, error => {
        swal(SwalErrorHandler.errorMessage(error));
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/components/admin/reporting/reporting.component.ts